
import { ChangeDetectionStrategy, Component } from '@angular/core'
import { PalantirSkeletonComponent } from '@fieldcontrol/palantir'

@Component({
    selector: 'order-warranty-skeleton',
    templateUrl: './warranty-skeleton.component.html',
    styleUrls: ['./warranty-skeleton.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PalantirSkeletonComponent]
})
export class MaintenanceWarrantySkeletonComponent {}
